import React from 'react';
import Popover from '@material-ui/core/Popover';
import { Picker } from 'emoji-mart';
import EmojiIcon from '@material-ui/icons/EmojiEmotionsRounded';

export default function EmojiPicker(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <EmojiIcon variant="contained" aria-describedby={id} onClick={handleClick} />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Picker title={props.title} onSelect={props.onPickEmoji} />
      </Popover>
    </div>
  );
}
